import React from 'react';
import { Mail, Phone, Clock } from 'lucide-react';
export function ContactInfo() {
  return <div className="space-y-6" data-id="element-65">
      <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-66">
        <h4 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-67">
          Get in Touch
        </h4>
        <p className="text-slate-600 mb-6" data-id="element-68">
          Have questions about your Santa Letter? Our elves are ready to help!
        </p>

        <div className="space-y-4" data-id="element-69">
          <div className="flex items-start gap-3" data-id="element-70">
            <div className="bg-red-100 p-2 rounded-lg text-red-600" data-id="element-71">
              <Clock className="w-5 h-5" data-id="element-72" />
            </div>
            <div data-id="element-73">
              <p className="font-medium text-slate-900" data-id="element-74">Support Hours</p>
              <p className="text-slate-600 text-sm" data-id="element-75">
                7 Days A Week: 9am to 7pm EST
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3" data-id="element-76">
            <div className="bg-blue-100 p-2 rounded-lg text-blue-600" data-id="element-77">
              <Mail className="w-5 h-5" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <p className="font-medium text-slate-900" data-id="element-80">Email Us</p>
              <a href="mailto:hello@santascertifiedletter.com" className="text-blue-600 hover:underline text-sm" data-id="element-81">
                hello@santascertifiedletter.com
              </a>
            </div>
          </div>

          <div className="flex items-start gap-3" data-id="element-82">
            <div className="bg-green-100 p-2 rounded-lg text-green-600" data-id="element-83">
              <Phone className="w-5 h-5" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <p className="font-medium text-slate-900" data-id="element-86">Call Us</p>
              <a href="tel:8005407716" className="text-slate-600 hover:text-slate-900 text-sm" data-id="element-87">
                (800) 540-7716
              </a>
            </div>
          </div>
        </div>
      </div>

      <p className="text-xs text-slate-400 text-center" data-id="element-88">
        We aim to respond to all inquiries within 24 hours during the holiday
        season.
      </p>
    </div>;
}